import { ReactNode } from "react";
import { Box } from "@mui/material";
import { HEADER_HEIGHT } from "~/components/AppHeader";
import { ROUTE_TABS_HEIGHT } from "~/components/RouteTabs";

const MAX_CONTENT_WIDTH = 1200;
const BASE_PADDING = 24;

interface DatasetPageLayoutProps {
  /** Content to render inside the scrollable area */
  children: ReactNode;
  /** Optional custom padding. Defaults to 3 (24px). */
  padding?: number;
  /** Optional background color. Defaults to transparent. */
  bgcolor?: string;
}

/**
 * Layout wrapper for dataset pages with fixed height, edge-aligned scrollbar,
 * and centered max-width content. Use instead of Container for consistent
 * scrollbar behavior across dataset detail pages.
 */
const DatasetPageLayout = ({ children, padding = 3, bgcolor }: DatasetPageLayoutProps) => {
  const contentHeight = `calc(100vh - ${HEADER_HEIGHT} - ${ROUTE_TABS_HEIGHT}px)`;

  return (
    <Box
      sx={{
        height: contentHeight,
        overflowY: "auto",
        bgcolor,
      }}
    >
      <Box
        sx={{
          py: padding,
          px: padding,
          maxWidth: MAX_CONTENT_WIDTH,
          mx: "auto",
          boxSizing: "border-box",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DatasetPageLayout;

// Export constants for pages that need custom layouts (like DatasetOverview)
export { MAX_CONTENT_WIDTH, BASE_PADDING };
